import Cookies from "js-cookie";

const MUTATING = new Set(["POST", "PUT", "PATCH", "DELETE"]);

// L-01 (MA-06): the JWT lives in an httpOnly mantis_session cookie now, not a
// Bearer header built from a localStorage-readable token. `credentials: "include"`
// is required on every call (not just mutating ones) — without it, a cross-origin
// request (frontend and backend are different subdomains) neither sends the cookie
// nor lets the browser store a Set-Cookie response, which matters most for
// login/signup/verifyToken. Mutating requests also need the CSRF header, read from
// the non-httpOnly csrfToken cookie the backend sets at login/verifyToken.
export async function apiFetch(url, options = {}) {
  const method = (options.method || "GET").toUpperCase();
  const headers = { ...(options.headers || {}) };

  // Clean up any case-insensitive duplicate headers to prevent sending the token twice
  for (const key of Object.keys(headers)) {
    if (key.toLowerCase() === "x-csrf-token") {
      delete headers[key];
    }
  }

  if (MUTATING.has(method)) {
    const csrf = Cookies.get("csrfToken");
    if (csrf) headers["X-CSRF-Token"] = csrf;
  }
  return fetch(url, { ...options, headers, credentials: "include" });
}
